var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4002 15.1L25.5002 23.7H7.2002L6.2002 15.1H7.7002L7.40021 9.29999H25.0002L24.7002 15.1H26.4002Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4002 15.1L25.5002 23.7H7.2002L6.2002 15.1H7.7002L7.40021 9.29999H25.0002L24.7002 15.1H26.4002Z",
    fill: "url(#paint0_linear_20_576)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4002 15.1L25.5002 23.7H7.2002L6.2002 15.1H7.7002L7.40021 9.29999H25.0002L24.7002 15.1H26.4002Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3001 23.7L24.0001 29.6H8.40012L8.1001 23.7H24.3001Z",
    fill: "url(#paint1_linear_20_576)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4 5.2V9.29999H4V5.2H9.40002L10.3 3H22.2L23.1 5.2H28.4Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7002 15.1H24.7002",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_576",
    x1: 15,
    y1: 9,
    x2: 15,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.741722,
    stopColor: "#9C6060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914128",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_576",
    x1: 26.019,
    y1: 29.7915,
    x2: 21.5888,
    y2: 18.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C6060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B5139"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.9ba034a85c0eef8f79abd21ecb43abfe.svg";
export { ForwardRef as ReactComponent };